import PropChainTracker from "../../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjGen from "../../../prop-tracker-utils/dict-tracker-obj-gen.js";

import LabelTrackerCreator from "./labels/label-tracker-creator.js";

class LabelCreation {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, labelCreator) {
        this._labelDataTracker = new PropChainTracker(evtCtx);
        const labelTrackLoader = new LabelTrackerCreator(this._labelDataTracker, labelCreator);
        const labelGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, labelTrackLoader);

        this._labels = labelGen;
    }

    get labels() { return this._labels; }

    track(labelData) {
        if (labelData) {
            this._labelDataTracker.track(labelData.data, ["value"]);
        } else {
            this._labelDataTracker.track();
        }
    }

    update() {
        this._labels.update();
    }
}

export default LabelCreation;
